module.exports = __webpack_public_path__ + "static/media/2.99f8cf70.jpg";